
import { ProgramModule_mkProgram, ProgramModule_withSubscription, ProgramModule_run } from "./fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { Program_withReactSynchronous } from "./fable_modules/Fable.Elmish.React.5.6.0/react.fs.js";
import { MessageModule_update, MessageModule_init, MessageModule_subscribe } from "./Message.fs.js";
import { render } from "./View.fs.js";

ProgramModule_run(Program_withReactSynchronous("elmish-app", ProgramModule_withSubscription(MessageModule_subscribe, ProgramModule_mkProgram(MessageModule_init, MessageModule_update, render))));

